import { InterviewRequestView } from "../../firestore/Types/RequestSchema";

export function InterviewRequest({ request }: { request: InterviewRequestView }) {
    return (
        <div className="section-box p-4">
            <div className="flex flex-row">
                <h3 className="section-title">Interview Request:</h3>
            </div>
        </div>
    );
}